import React from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";

// Components imports
import InputField from "../../common/InputField";
import Button from "../../common/Button";

// Scss imports
import css from "./ResetPasswordForm.module.scss";

// redux
import { useDispatch } from "react-redux";

interface ResetPasswordFormProps {
  onClickButtonHandler: Function;
  handleChange: Function;
  email: string;
  errorEmailText: string;
  disabledButton: any;
  onInputEmail: any;
  forgotPasswordMessage?: string;
}

const ResetPasswordForm: React.FC<ResetPasswordFormProps> = ({
  onClickButtonHandler,
  handleChange,
  email,
  errorEmailText,
  onInputEmail,
  disabledButton,
  forgotPasswordMessage
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  return (
    <form className={css.container}>
      <div className={css.inputFieldWrapper}>
        <InputField
          label="Е пошта"
          name="email"
          id="email"
          type="email"
          placeholder="email@gmail.com"
          value={email}
          handleChange={handleChange}
          handleOnFocus={(e: any) => (e.target.placeholder = "")}
          handleOnBlur={(e: any) => (e.target.placeholder = "email@gmail.com")}
          errorText={errorEmailText}
          onInputHandler={onInputEmail}
        />
      </div>
      <p className={css.message}>{forgotPasswordMessage}</p>
      <div className={css.buttonHolder}>
        <Button
          disabledButton={disabledButton}
          text="Ресетуј шифру"
          onButtonClickHandler={() =>
            //dispatch(login({ email: email }, history))
            onClickButtonHandler()
          }
        />
        <Link to="/signin">
          <p>Знате шифру, улогујте се</p>
        </Link>
      </div>
    </form>
  );
};

export default ResetPasswordForm;
